import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseCompanies } from 'services/connectwise';

export const ThunkGetConnectwiseCompanies = createAsyncThunk(
  'connectwise/getConnectwiseCompanies',
  (psaId: number) => getConnectwiseCompanies(psaId).then(res => res.data),
);

export default {};
